import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ButtonBar, SpinnerArea } from '../../../../shared/components';

import operTimelineService from '../../../../services/operTimelineService';
import useServiceReducer from '../../../../shared/hooks/useServiceReducer';
import timelineReducer from './timelineReducer';
import Graphic from './Graphic';
import MainContext from '../../../App/MainProvider/context';
import TimelineList from './List';
import { findMapId, findMapped } from '../../../../shared/misc/utils';

interface Props {
  operationId: number;
  onWidthset: (width: number) => void;
}

const Timeline = (props: Props) => {
  const { operationId, onWidthset } = props;
  const { t } = useTranslation();
  const { service } = useContext(MainContext);
  const [type, setType] = useState('graph');
  const [data, loading, , , , reload] = useServiceReducer(
    operTimelineService.getStages,
    timelineReducer,
    operationId
  );

  const saveMilestoneDate = (milestoneId: number, date: Date | null) => {
    service(() => operTimelineService.changeMilestoneDate({ date, milestoneId, operationId }), {
      callback: () => {
        reload();
      },
    });
  };

  const chartIcon: IconProp = 'chart-line';
  const listIcon: IconProp = 'list-ul';

  const buttonBarItems = [
    { id: 1, text: t('graphic'), mapped: 'graph', htmlId: 'graph', icon: chartIcon },
    { id: 2, text: t('list'), mapped: 'list', htmlId: 'list', icon: listIcon },
  ];

  return (
    <SpinnerArea loading={loading}>
      {data && (
        <>
          <div className="button-container-bar background-white">
            <div className="button-container-bar--left">
              <h5>{`${t('view')}:`}</h5>
              <ButtonBar
                id="queries"
                value={findMapId(buttonBarItems, type)}
                onChange={(value) => {
                  setType(findMapped(buttonBarItems, value));
                }}
                elements={buttonBarItems}
              />
            </div>
          </div>
          {type === 'graph' ? (
            <Graphic
              stages={data.stages}
              hidenMilestones={data.hidenMilestones}
              saveDate={saveMilestoneDate}
              onWidthset={onWidthset}
            />
          ) : (
            <TimelineList stages={data.stages} saveDate={saveMilestoneDate} />
          )}
        </>
      )}
    </SpinnerArea>
  );
};

export default Timeline;
